module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Black.03101ca8.woff2";